/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Telematics API
 * OpenAPI spec version: 1.0.0
 */
import axios from 'axios';
import type {
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

/**
 * GeoJSON representation of a Geometry.
 */
export interface Geometry {
  type?: string;
  coordinates?: number[][];
}

export type MachineCategoryCode = typeof MachineCategoryCode[keyof typeof MachineCategoryCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MachineCategoryCode = {
  AJE: 'AJE',
  CIS: 'CIS',
  KNA: 'KNA',
  KRM: 'KRM',
  MAN: 'MAN',
  NAK: 'NAK',
  NAV: 'NAV',
  NNN: 'NNN',
  OMA: 'OMA',
  OST: 'OST',
  OSA: 'OSA',
  POS: 'POS',
  PED: 'PED',
  SKM: 'SKM',
  SKR: 'SKR',
  SPC: 'SPC',
  SPP: 'SPP',
  SRN: 'SRN',
  T0: 'T0',
  T1: 'T1',
  T2: 'T2',
  T3: 'T3',
  T4: 'T4',
  TVS: 'TVS',
  ZAS: 'ZAS',
  ZLK: 'ZLK',
  ZSB: 'ZSB',
  ZSS: 'ZSS',
  XXX: 'XXX',
} as const;

export interface MachineUpdateTo {
  name: string;
  licencePlate: string;
  workingWidth: number;
  category: MachineCategoryCode;
  operationCode: string;
}

export interface DriveUpdateKeyTo {
  supplierKeyId?: number;
  customerKeyId?: number;
  equipmentKeyId?: number;
}

export interface WinfasClientUpdateTo {
  idNumber: string;
  name: string;
}

export interface WinfasUpdateTo {
  keys: DriveUpdateKeyTo;
  client?: WinfasClientUpdateTo;
}

export interface DriveKeyTo {
  id?: number;
  key?: string;
  name?: string;
  validity?: boolean;
}

export interface DriveKeysTo {
  supplierKey?: DriveKeyTo;
  customerKey?: DriveKeyTo;
  equipmentKey?: DriveKeyTo;
  client?: string;
  keySourceType?: KeySourceType;
}

export type KeySourceType = typeof KeySourceType[keyof typeof KeySourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const KeySourceType = {
  AUTOMATIC: 'AUTOMATIC',
  MANUAL: 'MANUAL',
} as const;

export interface WinfasClientTo {
  idNumber: string;
  name: string;
}

export interface WinfasTo {
  keys?: DriveKeysTo;
  client?: WinfasClientTo;
}

export interface HandworkCreateTo {
  timeFrom: string;
  timeTo: string;
  driver?: string;
  productionOperation?: string;
  bonus: number;
  winfas?: WinfasUpdateTo;
}

export interface EquipmentUpdateTo {
  name: string;
  workingWidth: number;
  operationCode: string;
}

export interface DriverUpdateTo {
  name: string;
}

export interface AccountUpdateTo {
  farmId: string;
  externalId?: string;
  enabled?: boolean;
  catalogue?: Catalogue;
  economicSystem?: EconomicSystem;
  economicSystemDate?: string;
  automaticActions?: boolean;
  dashboard?: boolean;
  fuelUsage?: boolean;
}

export type Catalogue = typeof Catalogue[keyof typeof Catalogue];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Catalogue = {
  SIDUS: 'SIDUS',
  WINFAS: 'WINFAS',
  JOHN_DEERE: 'JOHN_DEERE',
} as const;

export type EconomicSystem = typeof EconomicSystem[keyof typeof EconomicSystem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EconomicSystem = {
  TOS: 'TOS',
  SIDUS: 'SIDUS',
} as const;

export interface AccountTo {
  id?: number;
  farmId: string;
  name: string;
  externalId?: string;
  countryCode: string;
  enabled: boolean;
  activated?: string;
  deactivated?: string;
  zoneId?: string;
  catalogue?: Catalogue;
  economicSystem?: EconomicSystem;
  economicSystemDate?: string;
  automaticActions: boolean;
  dashboard: boolean;
  fuelUsage: boolean;
}

export interface E2eDrivePartRequest {
  start: string;
  end: string;
  cultivated: number;
  distance: number;
}

export interface E2eDriveRequest {
  parts: E2eDrivePartRequest[];
  machine: string;
  driver?: string;
  parcel?: string;
  equipment?: string;
  operation: string;
  ruleIds?: number[];
}

/**
 * If specified, rule applies to drives with this machine group. Use with machineGroupInverse for NOT logic.
 */
export type MachineGroupCode = typeof MachineGroupCode[keyof typeof MachineGroupCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MachineGroupCode = {
  COMBINE: 'COMBINE',
  LOADER: 'LOADER',
  TRUCK: 'TRUCK',
  PASSENGER: 'PASSENGER',
  TRACTOR: 'TRACTOR',
  OTHER: 'OTHER',
} as const;

export interface RuleCreateTo {
  /**
   * Human-readable name for the rule
   * @minLength 0
   * @maxLength 100
   */
  name: string;
  /** If specified, rule applies to drives with this crop code. Use with cropCodeInverse for NOT logic. */
  cropCode?: number;
  machineGroup?: MachineGroupCode;
  /**
   * If specified, rule applies to drives with this operation code. Use with operationCodeInverse for NOT logic.
   * @minLength 0
   * @maxLength 255
   */
  operationCode?: string;
  /**
   * If specified, rule applies to drives with this culture. Use with cultureInverse for NOT logic.
   * @minLength 0
   * @maxLength 255
   */
  culture?: string;
  /** When true, rule applies when crop code does NOT match the specified value. */
  cropCodeInverse: boolean;
  /** When true, rule applies when machine group does NOT match the specified value. */
  machineGroupInverse: boolean;
  /** When true, rule applies when operation code does NOT match the specified value. */
  operationCodeInverse: boolean;
  /** When true, rule applies when culture does NOT match the specified value. */
  cultureInverse: boolean;
  /** Optional date until which the rule is valid. If null, the rule never expires. */
  validTo?: string;
}

export interface RuleResponseTo {
  /** Unique identifier of the rule */
  id: number;
  /** ID of the farm account this rule belongs to */
  accountId: number;
  /** When the rule was created */
  created: string;
  /** Human-readable name for the rule */
  name: string;
  /** If specified, rule applies to drives with this crop code. Use with cropCodeInverse for NOT logic. */
  cropCode?: number;
  machineGroup?: MachineGroupCode;
  /** If specified, rule applies to drives with this operation code. Use with operationCodeInverse for NOT logic. */
  operationCode?: string;
  /** If specified, rule applies to drives with this culture. Use with cultureInverse for NOT logic. */
  culture?: string;
  /** When true, rule applies when crop code does NOT match the specified value. */
  cropCodeInverse: boolean;
  /** When true, rule applies when machine group does NOT match the specified value. */
  machineGroupInverse: boolean;
  /** When true, rule applies when operation code does NOT match the specified value. */
  operationCodeInverse: boolean;
  /** When true, rule applies when culture does NOT match the specified value. */
  cultureInverse: boolean;
  /** Date until which the rule is valid. If null, the rule never expires. */
  validTo?: string;
}

/**
 * Driver and machine filter for trajectory filtering
 */
export interface PositionLogbookDriverMachinePair {
  /** Drive part ID to filter by. Null means don't filter by drive part. */
  drivePartId?: number;
  /** Drive ID to filter by. Null means don't filter by drive. */
  driveId?: number;
  /** Driver ID to filter by. Null means no driver (for drives without a driver). */
  driverId?: number;
  /** Machine ID to filter by. Null means any machine. */
  machineId?: number;
  /** Filter type set: DRIVER filters by driver, MACHINE filters by machine. Include both to filter by both. Defaults to both. */
  type: PositionLogbookRequestType[];
}

/**
 * Request to get logbook positions with flexible filtering
 */
export interface PositionLogbookRequestTo {
  /** List of driver/machine filters to get trajectories for */
  pairs: PositionLogbookDriverMachinePair[];
}

/**
 * Filter type for logbook requests
 */
export type PositionLogbookRequestType = typeof PositionLogbookRequestType[keyof typeof PositionLogbookRequestType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PositionLogbookRequestType = {
  DRIVER: 'DRIVER',
  MACHINE: 'MACHINE',
} as const;

export interface DailyPositionTo {
  drivePartId?: number;
  driveId?: number;
  date: string;
  geometry: GeoJsonMultiLineString;
  gpsUnit: string;
  machineName?: string;
  licencePlate?: string;
  driverName?: string;
  driverCode?: string;
  equipmentName?: string;
  equipmentCode?: string;
}

export type GeoJsonCoordinatesItem = { [key: string]: unknown };

export interface GeoJson {
  type: GeoJsonType;
  coordinates: GeoJsonCoordinatesItem[];
}

export interface GeoJsonMultiLineString {
  type: GeoJsonType;
  coordinates: number[][][];
  geometries: GeoJson[];
}

export type GeoJsonType = typeof GeoJsonType[keyof typeof GeoJsonType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GeoJsonType = {
  Point: 'Point',
  MultiPoint: 'MultiPoint',
  LinearRing: 'LinearRing',
  LineString: 'LineString',
  MultiLineString: 'MultiLineString',
  Polygon: 'Polygon',
  MultiPolygon: 'MultiPolygon',
  GeometryCollection: 'GeometryCollection',
} as const;

export interface GeoJsonPoint {
  type: string;
  coordinates: number[];
}

export interface PositionFeatureTo {
  time: string;
  geometry: GeoJsonPoint;
  speed?: number;
}

export interface DrivePartCreateTo {
  parcelId?: string;
  timeFrom: string;
  timeTo: string;
  driver?: string;
  gpsUnit: string;
  equipment?: string;
  operation: TelematicsOperation;
  productionOperation?: string;
  workingWidth?: number;
  cultivated?: number;
  distance?: number;
  bonus: number;
}

export type TelematicsOperation = typeof TelematicsOperation[keyof typeof TelematicsOperation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TelematicsOperation = {
  PARCEL: 'PARCEL',
  TRANSFER: 'TRANSFER',
  TRANSPORT: 'TRANSPORT',
  REPAIR: 'REPAIR',
  HANDWORK: 'HANDWORK',
} as const;

export interface ActionDriveDetailPartTo {
  activityId?: string;
  area?: number;
  distance?: number;
}

export type Affiliation = typeof Affiliation[keyof typeof Affiliation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Affiliation = {
  COMPANY: 'COMPANY',
  EXTERNAL: 'EXTERNAL',
  NONE: 'NONE',
} as const;

export interface DrivePartDetailFarmTo {
  farmId?: number;
  companyNumber?: number;
}

export interface DrivePartDetailOperationTo {
  code?: string;
  name?: string;
}

export interface DrivePartDetailTo {
  id?: number;
  geometry?: Geometry;
  geometryStartAzimuth?: number;
  geometryStart?: Geometry;
  geometryEnd?: Geometry;
  geometryPerDay?: Geometry;
  parcelId?: string;
  centerKey?: string;
  cropKey?: number;
  cropName?: string;
  cropType?: string;
  season?: number;
  farm: DrivePartDetailFarmTo;
  timeFrom: string;
  timeTo: string;
  driver: DriverDrivePartDetailTo;
  machineName?: string;
  machineKeyCombination?: string;
  machineCategoryCode?: string;
  machineAffiliation: Affiliation;
  gpsUnit?: string;
  machine?: MachineDrivePartDetailTo;
  equipmentKeyCombination?: string;
  equipmentCode?: string;
  equipmentName?: string;
  equipmentAffiliation?: Affiliation;
  equipmentCompanyName?: string;
  equipment?: EquipmentDrivePartDetailTo;
  workingWidth?: number;
  operation: TelematicsOperation;
  productionOperation?: DrivePartDetailOperationTo;
  parcel?: ParcelInfoTo;
  fuel?: FuelLogbookItemTo;
  action: ActionDriveDetailPartTo;
  source: Source;
  state: State;
  type: Type;
}

export interface DriverDrivePartDetailTo {
  name?: string;
  code?: string;
  personalNumber?: string;
  bonus?: number;
  isEmployee: boolean;
  affiliation?: Affiliation;
  companyName?: string;
}

export interface EquipmentDrivePartDetailTo {
  name?: string;
  code?: string;
  keyCombination?: string;
  affiliation?: Affiliation;
  companyName?: string;
}

export interface FuelLogbookItemTo {
  usedFuel: number;
  avgFuel: number;
  fuelUnit: FuelUnit;
}

export type FuelUnit = typeof FuelUnit[keyof typeof FuelUnit];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FuelUnit = {
  LITRE_HA: 'LITRE_HA',
  LITRE_KM: 'LITRE_KM',
  LITRE_H: 'LITRE_H',
} as const;

export interface GeoJsonMultiPolygon {
  type: GeoJsonType;
  coordinates: number[][][][];
  geometries: GeoJson[];
}

export interface MachineDrivePartDetailTo {
  name?: string;
  gpsUnit?: string;
  keyCombination?: string;
  categoryCode?: string;
  affiliation?: Affiliation;
  companyName?: string;
}

export interface ParcelInfoTo {
  geometry?: GeoJsonMultiPolygon;
  localName?: string;
  blockNumber?: string;
  square?: string;
  subjectId?: string;
  subjectName?: string;
  area?: number;
  affiliation?: Affiliation;
}

export type Source = typeof Source[keyof typeof Source];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Source = {
  MANUAL: 'MANUAL',
  EUROWAG: 'EUROWAG',
  JOHN_DEERE: 'JOHN_DEERE',
} as const;

export type State = typeof State[keyof typeof State];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const State = {
  DEFERRED: 'DEFERRED',
  NOT_APPROVED: 'NOT_APPROVED',
  APPROVED: 'APPROVED',
  THIRD_PARTY_ACKNOWLEDGED: 'THIRD_PARTY_ACKNOWLEDGED',
} as const;

export type Type = typeof Type[keyof typeof Type];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Type = {
  AUTOMATIC: 'AUTOMATIC',
  UPDATED: 'UPDATED',
  MANUAL: 'MANUAL',
  SEPARATED: 'SEPARATED',
  HANDWORK: 'HANDWORK',
} as const;

export interface DriveCreateTo {
  timeFrom: string;
  timeTo: string;
  driver?: string;
  gpsUnit: string;
  equipment?: string;
  operation: TelematicsOperation;
  productionOperation?: string;
  parcelId?: string;
  season?: number;
  workingWidth?: number;
  cultivated?: number;
  distance?: number;
  bonus: number;
}

export interface DriveDetailActionTo {
  actionId?: string;
  actionCode?: string;
}

export interface DriveDetailDriverTo {
  id?: number;
  name?: string;
  code?: string;
  personalNumber?: string;
  bonus?: number;
  isEmployee: boolean;
  affiliation?: Affiliation;
  companyName?: string;
}

export interface DriveDetailEquipmentTo {
  name?: string;
  code?: string;
  affiliation?: Affiliation;
  companyName?: string;
}

export interface DriveDetailFarmTo {
  farmId?: number;
  companyNumber?: number;
}

export interface DriveDetailMachineTo {
  id?: number;
  name?: string;
  gpsUnit?: string;
  affiliation?: Affiliation;
  companyName?: string;
}

export interface DriveDetailOperationTo {
  code?: string;
  name?: string;
}

export interface DriveDetailPartTo {
  dateFrom: string;
  dateTo: string;
  geometry?: Geometry;
}

export interface DriveDetailTo {
  id: number;
  drivePart: DriveDetailPartTo[];
  parcelId?: string;
  centerKey?: string;
  cropKey?: number;
  cropName?: string;
  cropType?: string;
  season?: number;
  farm: DriveDetailFarmTo;
  dateFrom: string;
  duration: number;
  driver: DriveDetailDriverTo;
  machineName?: string;
  machineCategoryCode?: string;
  machineAffiliation: Affiliation;
  gpsUnit?: string;
  machine?: DriveDetailMachineTo;
  equipmentCode?: string;
  equipmentName?: string;
  equipmentAffiliation?: Affiliation;
  equipmentCompanyName?: string;
  equipment?: DriveDetailEquipmentTo;
  workingWidth?: number;
  operation: TelematicsOperation;
  productionOperation?: DriveDetailOperationTo;
  parcel?: ParcelInfoTo;
  cultivated?: number;
  distance?: number;
  fuel?: FuelLogbookItemTo;
  validation: DriveDetailValidationTo;
  actions: DriveDetailActionTo[];
  appliedRules: DriveRuleTo[];
  source: Source;
  state: State;
  type: Type;
  geometryPerDay?: Geometry;
}

export interface DriveDetailValidationTo {
  isComplete: boolean;
  validationErrors: DriveValidationType[];
  complete?: boolean;
}

export interface DriveRuleTo {
  id: number;
  accountId: number;
  name: string;
  cropCode?: number;
  cropCodeInverse?: boolean;
  machineGroup?: MachineGroupCode;
  machineGroupInverse?: boolean;
  operationCode?: string;
  operationCodeInverse?: boolean;
  culture?: string;
  cultureInverse?: boolean;
  created: string;
  validTo?: string;
  isValid: boolean;
  isDeleted: boolean;
}

export type DriveValidationType = typeof DriveValidationType[keyof typeof DriveValidationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DriveValidationType = {
  CENTER_EXISTS: 'CENTER_EXISTS',
  CROP_EXISTS: 'CROP_EXISTS',
  CULTIVATED_NOT_ZERO: 'CULTIVATED_NOT_ZERO',
  DISTANCE_NOT_ZERO: 'DISTANCE_NOT_ZERO',
  DURATION_NOT_ZERO: 'DURATION_NOT_ZERO',
  DRIVER_EXISTS: 'DRIVER_EXISTS',
  MACHINE_AFFILIATION_COMPANY: 'MACHINE_AFFILIATION_COMPANY',
  PARCEL_EXISTS: 'PARCEL_EXISTS',
  PRODUCTION_OPERATION_EXISTS: 'PRODUCTION_OPERATION_EXISTS',
  SUPPLIER_KEY_EXISTS: 'SUPPLIER_KEY_EXISTS',
  SUPPLIER_KEY_VALID: 'SUPPLIER_KEY_VALID',
  CUSTOMER_KEY_EXISTS: 'CUSTOMER_KEY_EXISTS',
  CUSTOMER_KEY_VALID: 'CUSTOMER_KEY_VALID',
  CLIENT_EXISTS: 'CLIENT_EXISTS',
  CLIENT_NOT_EXISTS: 'CLIENT_NOT_EXISTS',
  TIMES_DONT_OVERLAP: 'TIMES_DONT_OVERLAP',
} as const;

export type GeoJsonLineString = Geometry;

export interface DriveUpdateTo {
  timeFrom?: string;
  timeTo?: string;
  driver?: string;
  gpsUnit: string;
  equipment?: string;
  operation: TelematicsOperation;
  productionOperation?: string;
  parcelId?: string;
  parcelAffiliation?: Affiliation;
  season?: number;
  workingWidth?: number;
  cultivated?: number;
  distance?: number;
  bonus: number;
}

export interface DriveSeparationTimeTo {
  time: string;
}

export interface DriveSeparationIntervalTo {
  timeFrom: string;
  timeTo: string;
}

export interface DriveSeparationIntervalsTo {
  intervals: DriveSeparationIntervalTo[];
}

export interface DriveRecalculateTo {
  gpsUnit: string;
  equipment?: string;
  workingWidth?: number;
}

export interface DriveAreaTo {
  area?: number;
}

export interface DriveUpdateStateTo {
  drive: number[];
  state: State;
}

export interface DriveOverlapRequestTo {
  date: string;
  driver: string;
}

export interface DriveDetailOverlapTo {
  dateFrom: string;
  dateTo: string;
  type: Type;
  state: State;
}

/**
 * Request to precalculate available time intervals for handwork
 */
export interface HandworkPrecalculateRequestTo {
  /** Start time for the handwork */
  timeFrom: string;
  /** End time for the handwork */
  timeTo: string;
  /** Driver code */
  driver: string;
  /** Drive ID to exclude from overlap detection (used when editing existing handwork) */
  driveId?: number;
}

/**
 * Time interval available for handwork
 */
export interface HandworkIntervalTo {
  /** Start time of the interval */
  dateFrom: string;
  /** End time of the interval */
  dateTo: string;
}

/**
 * Response containing available time intervals and total duration for handwork
 */
export interface HandworkPrecalculateResponseTo {
  /** List of available time intervals */
  intervals: HandworkIntervalTo[];
  /** Total duration in seconds */
  totalDurationSeconds: number;
}

export interface DriveBatchUpdateSubjectTo {
  drive: number[];
  subject?: string;
}

export interface DriveBatchUpdateProductionOperationTo {
  drive: number[];
  productionOperation: number;
}

export interface DriveBatchUpdateCustomerKeyTo {
  drive: number[];
  customerKeyId: number;
}

export interface DriveBatchUpdateEquipmentTo {
  drive: number[];
  equipment: number;
}

export interface DriveBatchUpdateDriverTo {
  drive: number[];
  driver: number;
}

export interface DriveBatchUpdateBonusTo {
  drive: number[];
  bonus: number;
}

export interface AccountCreateTo {
  farmId: string;
  name: string;
  externalId: string;
  countryCode: string;
  enabled: boolean;
  catalogue?: Catalogue;
  economicSystem?: EconomicSystem;
  economicSystemDate?: string;
  automaticActions: boolean;
  dashboard: boolean;
  fuelUsage: boolean;
}

export type KeyType = typeof KeyType[keyof typeof KeyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const KeyType = {
  SUPPLIER: 'SUPPLIER',
  CUSTOMER: 'CUSTOMER',
  EQUIPMENT: 'EQUIPMENT',
} as const;

export interface OperationTo {
  code: TelematicsOperation;
  name: string;
}

export interface ProductionOperationTo {
  id?: number;
  code?: string;
  name?: string;
  bonus?: number;
}

export type MachineSortColumn = typeof MachineSortColumn[keyof typeof MachineSortColumn];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MachineSortColumn = {
  GPS_UNIT: 'GPS_UNIT',
  NAME: 'NAME',
  LICENCE_PLATE: 'LICENCE_PLATE',
  WORKING_WIDTH: 'WORKING_WIDTH',
  VALID_FROM: 'VALID_FROM',
  VALID_TO: 'VALID_TO',
} as const;

export interface DeviceCompanyTo {
  id?: string;
}

export interface DeviceOperationTo {
  id?: string;
  name?: string;
  bonus?: number;
}

export interface MachineTo {
  id?: number;
  machineCode?: string;
  keyCombination?: string;
  operation?: DeviceOperationTo;
  type?: string;
  licencePlate?: string;
  name?: string;
  workingWidth?: number;
  gpsUnit: string;
  unitPhoneNo?: string;
  company?: DeviceCompanyTo;
  validFrom: string;
  validTo?: string;
  profileCode?: string;
  group: MachineGroupCode;
  groupName?: string;
  category: MachineCategoryCode;
  categoryName?: string;
}

export interface GeoJsonMultiPoint {
  type: GeoJsonType;
  coordinates: number[][];
}

export interface PositionDetailTo {
  state: PositionState;
  time: string;
  movementTime?: string;
  location: GeoJsonMultiPoint;
  machine?: PositionMachineTo;
  driver?: PositionDriverTo;
  equipment?: PositionEquipmentTo;
  speed?: number;
  azimuth?: number;
}

export interface PositionDriverTo {
  name?: string;
  code: string;
}

export interface PositionEquipmentTo {
  name?: string;
  code: string;
}

export interface PositionMachineTo {
  name?: string;
  machineCode?: string;
  type?: string;
  operation?: string;
  licencePlate?: string;
  gpsUnit: string;
  group?: MachineGroupCode;
}

export type PositionState = typeof PositionState[keyof typeof PositionState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PositionState = {
  MOVING: 'MOVING',
  ON: 'ON',
  OFF: 'OFF',
  MISSING: 'MISSING',
} as const;

/**
 * Logbook dashboard item grouped by driver and machine
 */
export interface PositionLogbookDashboardTo {
  /** Driver ID */
  driverId?: number;
  /** Driver code */
  driverCode?: string;
  /** Driver name */
  driverName?: string;
  /** Machine ID */
  machineId: number;
  /** Machine GPS unit identifier */
  machineGpsUnit: string;
  /** Machine name */
  machineName?: string;
  /** Machine licence plate */
  machineLicencePlate?: string;
  machineGroup: MachineGroupCode;
}

export type PositionSort = typeof PositionSort[keyof typeof PositionSort];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PositionSort = {
  STATE: 'STATE',
  MACHINE_NAME: 'MACHINE_NAME',
} as const;

export interface PositionDashboard {
  state: PositionState;
  position?: GeoJsonMultiPoint;
  time?: string;
  movementTime?: string;
  speed: number;
  azimuth?: number;
  ignition: boolean;
  machineGpsUnit: string;
  machineName?: string;
  machineGroup: MachineGroupCode;
  machineLicencePlate?: string;
  driverCode?: string;
  driverName?: string;
  equipmentCode?: string;
  equipmentName?: string;
  hasTrajectory: boolean;
}

export interface MachineGroupTo {
  code: MachineGroupCode;
  value: string;
}

export interface MachineGroupCategoryTo {
  id: number;
  code: string;
  group: MachineGroupTo;
  name: string;
}

export type LogbookSortColumn = typeof LogbookSortColumn[keyof typeof LogbookSortColumn];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LogbookSortColumn = {
  FROM: 'FROM',
  DRIVER_NAME: 'DRIVER_NAME',
  OPERATION_NAME: 'OPERATION_NAME',
  MACHINE_NAME: 'MACHINE_NAME',
  DISTANCE: 'DISTANCE',
  CULTIVATED: 'CULTIVATED',
} as const;

export interface DriverIdentityTo {
  name?: string;
  code?: string;
  affiliation?: Affiliation;
  companyName?: string;
}

export interface EquipmentLogbookItemTo {
  code?: string;
  name?: string;
  affiliation?: Affiliation;
  width?: number;
  companyName?: string;
}

export type KeyCustomerType = typeof KeyCustomerType[keyof typeof KeyCustomerType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const KeyCustomerType = {
  CURRENT: 'CURRENT',
  FUTURE: 'FUTURE',
  OTHER: 'OTHER',
} as const;

export interface LogbookItemTo {
  id: string;
  from: string;
  to: string;
  driver?: DriverIdentityTo;
  operation?: string;
  productionOperation?: OperationLogbookItemTo;
  parcel?: SimpleParcelInfoTo;
  cultivated?: number;
  parcelArea?: number;
  distance?: number;
  fuel?: FuelLogbookItemTo;
  bonus?: number;
  gpsUnit?: string;
  machineName?: string;
  machineLicencePlate?: string;
  machineAffiliation: Affiliation;
  machine?: MachineLogbookItemTo;
  equipment?: EquipmentLogbookItemTo;
  winfas?: WinfasLogbookItemTo;
  cropCode?: number;
  cropKey?: number;
  cropName?: string;
  cropType?: string;
  source: Source;
  state: State;
  type: Type;
}

export interface MachineLogbookItemTo {
  gpsUnit?: string;
  name?: string;
  licencePlate?: string;
  affiliation?: Affiliation;
  companyName?: string;
}

export interface OperationLogbookItemTo {
  code?: string;
  name?: string;
}

export interface SimpleParcelInfoTo {
  localName?: string;
  blockNumber?: string;
  square?: string;
  subjectId?: string;
  subjectName?: string;
  area?: number;
  affiliation?: Affiliation;
}

export interface WinfasClientLogbookItemTo {
  idNumber: string;
  name: string;
}

export type WinfasKeyCustomerLogbookItemToParts = {[key: string]: string};

export interface WinfasKeyCustomerLogbookItemTo {
  key: string;
  parts: WinfasKeyCustomerLogbookItemToParts;
  type?: KeyCustomerType;
}

export type WinfasKeyEquipmentLogbookItemToParts = {[key: string]: string};

export interface WinfasKeyEquipmentLogbookItemTo {
  key?: string;
  parts: WinfasKeyEquipmentLogbookItemToParts;
}

export type WinfasKeySupplierLogbookItemToParts = {[key: string]: string};

export interface WinfasKeySupplierLogbookItemTo {
  key?: string;
  parts: WinfasKeySupplierLogbookItemToParts;
}

export interface WinfasKeysLogbookItemTo {
  supplierKey?: WinfasKeySupplierLogbookItemTo;
  customerKey?: WinfasKeyCustomerLogbookItemTo;
  equipmentKey?: WinfasKeyEquipmentLogbookItemTo;
}

export interface WinfasLogbookItemTo {
  keys?: WinfasKeysLogbookItemTo;
  client?: WinfasClientLogbookItemTo;
}

export interface EconomicStatsTo {
  count: number;
  dateFrom?: string;
  dateTo?: string;
}

export interface StreamingResponseBody { [key: string]: unknown }

export type LogbookAggregatedSortColumn = typeof LogbookAggregatedSortColumn[keyof typeof LogbookAggregatedSortColumn];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LogbookAggregatedSortColumn = {
  FROM: 'FROM',
  DRIVER_NAME: 'DRIVER_NAME',
  MACHINE_NAME: 'MACHINE_NAME',
  DURATION: 'DURATION',
  DISTANCE: 'DISTANCE',
  CULTIVATED: 'CULTIVATED',
} as const;

export interface DriverLogbookItemTo {
  code?: string;
  name?: string;
  affiliation?: Affiliation;
  companyName?: string;
}

export interface LogbookAggregatedFuelTo {
  usedFuel: number;
}

export interface LogbookAggregatedItemTo {
  id: string;
  dateFrom: string;
  duration: number;
  operation?: string;
  productionOperation?: OperationLogbookItemTo;
  parcel?: SimpleParcelInfoTo;
  cultivated?: number;
  parcelArea?: number;
  distance?: number;
  fuel?: FuelLogbookItemTo;
  bonus?: number;
  gpsUnit?: string;
  machineName?: string;
  machineLicencePlate?: string;
  machineAffiliation: Affiliation;
  machine?: MachineLogbookItemTo;
  driver?: DriverLogbookItemTo;
  equipment?: EquipmentLogbookItemTo;
  winfas?: WinfasLogbookItemTo;
  validation: ValidationLogbookItemTo;
  cropKey?: number;
  cropName?: string;
  cropType?: string;
  source: Source;
  state: State;
  type: Type;
}

export interface LogbookAggregatedTimeTo {
  dateFrom: string;
  dateTo: string;
  type: Type;
  state: State;
  operation?: string;
}

export interface LogbookAggregatedTo {
  driver?: DriverIdentityTo;
  dateFrom: string;
  dateTo: string;
  times: LogbookAggregatedTimeTo[];
  duration: number;
  cultivated: number;
  distance: number;
  fuel?: LogbookAggregatedFuelTo;
  drives: LogbookAggregatedItemTo[];
}

export interface ValidationLogbookItemTo {
  isComplete: boolean;
  validationErrors: DriveValidationType[];
  complete?: boolean;
}

/**
 * Reason for calculation failure
 */
export type CalculationFailureReason = typeof CalculationFailureReason[keyof typeof CalculationFailureReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CalculationFailureReason = {
  MISSING_PARCEL_CROP: 'MISSING_PARCEL_CROP',
  MISSING_CENTER_KEY: 'MISSING_CENTER_KEY',
  CROP_NOT_FOUND: 'CROP_NOT_FOUND',
  KEY_COMBINATION_NOT_FOUND: 'KEY_COMBINATION_NOT_FOUND',
  UNSUPPORTED_AFFILIATION: 'UNSUPPORTED_AFFILIATION',
} as const;

/**
 * Center key extraction details
 */
export interface CenterKeyDetailTo {
  /** Whether center key was successfully extracted */
  success: boolean;
  /** The center key value from parcel */
  value?: string;
}

/**
 * Crop key selection condition
 */
export type CropKeyCondition = typeof CropKeyCondition[keyof typeof CropKeyCondition];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CropKeyCondition = {
  FERTILIZATION: 'FERTILIZATION',
  CATCH_CROP_GPS: 'CATCH_CROP_GPS',
  CATCH_CROP: 'CATCH_CROP',
  GPS: 'GPS',
  DEFAULT: 'DEFAULT',
} as const;

/**
 * Crop key selection details
 */
export interface CropKeyDetailTo {
  /** Whether crop key selection was successful */
  success: boolean;
  matchedCondition?: CropKeyCondition;
  /** The selected crop key value before seasonal offset */
  selectedValue?: number;
  /** Crop entity ID */
  cropId?: number;
  /** Crop name for display */
  cropName?: string;
  /** Equipment/machine profile code used in selection */
  profileCode?: string;
  /** Parcel crop seed type (e.g., CATCH_CROP) */
  parcelCropSeedType?: string;
  /** Parcel harvest product ID */
  parcelHarvestProduct?: number;
  /** Parcel harvest product name from static catalogue (e.g., 'seno', 'semeno'). Note: Currently uses static mapping; will be replaced with Agroevidence API in the future. */
  parcelHarvestProductName?: string;
}

/**
 * Customer key calculation details for tooltip display
 */
export interface CustomerKeyCalculationTo {
  calculationType: CustomerKeyCalculationType;
  failureReason?: CalculationFailureReason;
  centerKey?: CenterKeyDetailTo;
  cropKey?: CropKeyDetailTo;
  seasonalOffset?: SeasonalOffsetDetailTo;
  keyCombination?: KeyCombinationDetailTo;
  resultKey?: DriveKeyTo;
}

/**
 * Type of customer key calculation
 */
export type CustomerKeyCalculationType = typeof CustomerKeyCalculationType[keyof typeof CustomerKeyCalculationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomerKeyCalculationType = {
  STANDARD_CALCULATION: 'STANDARD_CALCULATION',
  USES_SUPPLIER_KEY: 'USES_SUPPLIER_KEY',
  NOT_CALCULABLE: 'NOT_CALCULABLE',
  MANUAL_OVERRIDE: 'MANUAL_OVERRIDE',
} as const;

/**
 * Key combination lookup details
 */
export interface KeyCombinationDetailTo {
  /** Whether key combination lookup was successful */
  success: boolean;
  /** Ordered key combination format (1::centerKey,,2::cropKey) */
  orderedFormat?: string;
  /** Unordered key combination format (cropKey-centerKey) */
  unorderedFormat?: string;
  /** Whether the combination was found in Winfas catalogue */
  foundInCatalogue: boolean;
}

/**
 * Seasonal offset application details
 */
export interface SeasonalOffsetDetailTo {
  /** Whether seasonal offset was applied */
  applied: boolean;
  /** Offset amount (typically -300 or 0) */
  offsetAmount: number;
  /** Crop key value before offset */
  originalValue?: number;
  /** Crop key value after offset */
  finalValue?: number;
  /** Parcel season year */
  parcelSeason?: number;
  /** Drive date used for season determination */
  driveDate?: string;
}

export interface DriveParcelCropTo {
  parcelId: number;
  parcelArea?: number;
  parcelSeason?: number;
  cropName?: string;
  parcelHarvestProduct?: number;
  parcelCropSeedType: string;
  parcelCulture: string;
}

export interface DriveSubjectTo {
  id: string;
  name: string;
}

export type LogbookDriveSortColumn = typeof LogbookDriveSortColumn[keyof typeof LogbookDriveSortColumn];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LogbookDriveSortColumn = {
  FROM: 'FROM',
  DRIVER_NAME: 'DRIVER_NAME',
  OPERATION_NAME: 'OPERATION_NAME',
  MACHINE_NAME: 'MACHINE_NAME',
  DISTANCE: 'DISTANCE',
  CULTIVATED: 'CULTIVATED',
} as const;

export interface LogbookAggregatedMachineTo {
  machine: SimpleMachineTo;
  machineAffiliation: Affiliation;
  machineCompanyName?: string;
  dateFrom: string;
  dateTo: string;
  times: LogbookAggregatedTimeTo[];
  duration: number;
  cultivated: number;
  distance: number;
  fuel?: LogbookAggregatedFuelTo;
  drives: LogbookAggregatedItemTo[];
}

export interface SimpleMachineTo {
  id?: number;
  categoryCode?: string;
  group: MachineGroupCode;
  operation?: DeviceOperationTo;
  licencePlate?: string;
  name?: string;
  workingWidth?: number;
  gpsUnit: string;
  profileCode?: string;
}

/**
 * Handwork aggregated item with original request times and drive information
 */
export interface HandworkAggregatedItemTo {
  /** Original requested start time for the handwork */
  timeFrom: string;
  /** Original requested end time for the handwork */
  timeTo: string;
  drive: LogbookAggregatedItemTo;
}

/**
 * Handwork detail response with original request times and drive information
 */
export interface HandworkDetailTo {
  /** Original requested start time for the handwork */
  timeFrom: string;
  /** Original requested end time for the handwork */
  timeTo: string;
  driveDetail: DriveDetailTo;
}

export interface ActionDriveTo {
  driveId: number;
  driveAffiliation: Affiliation;
  farmId: number;
  farmName: string;
  companyId: string;
  gpsUnit?: string;
  machineName?: string;
  driverCode?: string;
  driverName?: string;
  equipmentCode?: string;
  equipmentName?: string;
  operationCode?: string;
  operationName?: string;
}

export type ActionDrivesToParcels = {[key: string]: ActionDriveTo[]};

export interface ActionDrivesTo {
  parcels: ActionDrivesToParcels;
}

export interface DriveImportTo {
  id?: number;
  started?: string;
  finished?: string;
  state?: ImportState;
  source?: Source;
  filename?: string;
}

export type ImportState = typeof ImportState[keyof typeof ImportState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImportState = {
  STARTED: 'STARTED',
  ERROR: 'ERROR',
  COMPLETED: 'COMPLETED',
} as const;

export type EquipmentSortColumn = typeof EquipmentSortColumn[keyof typeof EquipmentSortColumn];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EquipmentSortColumn = {
  CODE: 'CODE',
  NAME: 'NAME',
  WORKING_WIDTH: 'WORKING_WIDTH',
  VALID_FROM: 'VALID_FROM',
  VALID_TO: 'VALID_TO',
} as const;

export interface EquipmentCompanyTo {
  id?: string;
}

export interface EquipmentOperationTo {
  id?: string;
  name?: string;
  bonus?: number;
}

export interface EquipmentTo {
  id?: number;
  name?: string;
  code: string;
  company?: EquipmentCompanyTo;
  operation?: EquipmentOperationTo;
  workingWidth?: number;
  validFrom: string;
  validTo?: string;
  profileCode?: string;
}

export type DriverSortColumn = typeof DriverSortColumn[keyof typeof DriverSortColumn];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DriverSortColumn = {
  CODE: 'CODE',
  NAME: 'NAME',
  VALID_FROM: 'VALID_FROM',
  VALID_TO: 'VALID_TO',
} as const;

export interface DriverCompanyTo {
  id?: string;
}

export interface DriverTo {
  id?: number;
  name?: string;
  code: string;
  personalNumber?: string;
  company?: DriverCompanyTo;
  validFrom: string;
  validTo?: string;
}

export type CropSortColumn = typeof CropSortColumn[keyof typeof CropSortColumn];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CropSortColumn = {
  NAME: 'NAME',
} as const;

export interface CropTo {
  id?: number;
  name?: string;
  code: number;
  key?: number;
}

export type AccountSortColumn = typeof AccountSortColumn[keyof typeof AccountSortColumn];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountSortColumn = {
  FARM_ID: 'FARM_ID',
  NAME: 'NAME',
  EXTERNAL_ID: 'EXTERNAL_ID',
  COUNTRY_CODE: 'COUNTRY_CODE',
  ENABLED: 'ENABLED',
  ACTIVATED: 'ACTIVATED',
  DEACTIVATED: 'DEACTIVATED',
} as const;

export interface AccountStatusTo {
  telematics: boolean;
  externalId?: string;
  catalogue?: Catalogue;
  economicSystem?: EconomicSystem;
  economicSystemDate?: string;
  automaticActions: boolean;
  dashboard: boolean;
  fuelUsage: boolean;
}

export type UpdateMachineParams = {
farmIds?: number;
};

type GetParamsTSMorphBase = {
farmIds: number;
}

export type GetParams = Omit<GetParamsTSMorphBase, "farmIds">;;

type UpdateKeysParamsTSMorphBase = {
farmIds: number;
}

export type UpdateKeysParams = Omit<UpdateKeysParamsTSMorphBase, "farmIds">;;

type HandworkDetailParamsTSMorphBase = {
farmIds: number;
language?: string;
}

export type HandworkDetailParams = Omit<HandworkDetailParamsTSMorphBase, "farmIds">;;

type UpdateHandworkParamsTSMorphBase = {
farmIds: number;
language?: string;
}

export type UpdateHandworkParams = Omit<UpdateHandworkParamsTSMorphBase, "farmIds">;;

export type UpdateEquipmentParams = {
farmIds?: number;
};

export type UpdateDriverParams = {
farmIds?: number;
};

export type GetAll8Params = {
page?: number;
'per-page'?: number;
'sort-col'?: AccountSortColumn;
'sort-dir'?: string;
search?: string;
countryCode?: string[];
enabled?: boolean;
catalogue?: Catalogue;
economicSystem?: EconomicSystem;
};

type ListRulesParamsTSMorphBase = {
farmIds: number;
search?: string;
}

export type ListRulesParams = Omit<ListRulesParamsTSMorphBase, "farmIds">;;

type CreateRuleParamsTSMorphBase = {
farmIds: number;
}

export type CreateRuleParams = Omit<CreateRuleParamsTSMorphBase, "farmIds">;;

type GetLogbookPositionsParamsTSMorphBase = {
farmIds: number;
'date-from': string;
'date-to': string;
}

export type GetLogbookPositionsParams = Omit<GetLogbookPositionsParamsTSMorphBase, "farmIds">;;

type GetLogbookFeaturesParamsTSMorphBase = {
farmIds: number;
'date-from': string;
'date-to': string;
}

export type GetLogbookFeaturesParams = Omit<GetLogbookFeaturesParamsTSMorphBase, "farmIds">;;

type GetLogbookFeaturesV2ParamsTSMorphBase = {
farmIds: number;
'date-from': string;
'date-to': string;
}

export type GetLogbookFeaturesV2Params = Omit<GetLogbookFeaturesV2ParamsTSMorphBase, "farmIds">;;

type LogbookParamsTSMorphBase = {
farmIds: number;
page?: number;
'per-page'?: number;
'sort-col'?: LogbookSortColumn;
'sort-dir'?: string;
language?: string;
dateFrom?: string;
dateTo?: string;
search?: string;
actionState?: string[];
crop?: number[];
operation?: TelematicsOperation[];
affiliation?: Affiliation[];
productionOperation?: string[];
actionType?: string[];
parcel?: number[];
parcelSubjectId?: string[];
driver?: string[];
gpsUnit?: string[];
equipment?: string[];
state?: State[];
}

export type LogbookParams = Omit<LogbookParamsTSMorphBase, "farmIds">;;

type CreateParamsTSMorphBase = {
farmIds: number;
language?: string;
}

export type CreateParams = Omit<CreateParamsTSMorphBase, "farmIds">;;

type TosExportParamsTSMorphBase = {
farmIds: number;
language?: string;
}

export type TosExportParams = Omit<TosExportParamsTSMorphBase, "farmIds">;;

type TosExcelExportParamsTSMorphBase = {
farmIds: number;
language?: string;
}

export type TosExcelExportParams = Omit<TosExcelExportParamsTSMorphBase, "farmIds">;;

type LogbookByDriversParamsTSMorphBase = {
farmIds: number;
page?: number;
'per-page'?: number;
'sort-col'?: LogbookAggregatedSortColumn;
'sort-dir'?: string;
language?: string;
dateFrom?: string;
dateTo?: string;
driver?: string;
machine?: string;
state?: State[];
}

export type LogbookByDriversParams = Omit<LogbookByDriversParamsTSMorphBase, "farmIds">;;

type Create1ParamsTSMorphBase = {
farmIds: number;
language?: string;
}

export type Create1Params = Omit<Create1ParamsTSMorphBase, "farmIds">;;

type DriveDetail1ParamsTSMorphBase = {
farmIds: number;
language?: string;
}

export type DriveDetail1Params = Omit<DriveDetail1ParamsTSMorphBase, "farmIds">;;

type UpdateParamsTSMorphBase = {
farmIds: number;
language?: string;
}

export type UpdateParams = Omit<UpdateParamsTSMorphBase, "farmIds">;;

type _DeleteParamsTSMorphBase = {
farmIds: number;
}

export type _DeleteParams = Omit<_DeleteParamsTSMorphBase, "farmIds">;;

type SeparateDriveByTimeParamsTSMorphBase = {
farmIds: number;
language?: string;
}

export type SeparateDriveByTimeParams = Omit<SeparateDriveByTimeParamsTSMorphBase, "farmIds">;;

type SeparateDriveByIntervalParamsTSMorphBase = {
farmIds: number;
language?: string;
}

export type SeparateDriveByIntervalParams = Omit<SeparateDriveByIntervalParamsTSMorphBase, "farmIds">;;

type RecalculateAreaParamsTSMorphBase = {
farmIds: number;
}

export type RecalculateAreaParams = Omit<RecalculateAreaParamsTSMorphBase, "farmIds">;;

type SetStateParamsTSMorphBase = {
farmIds: number;
}

export type SetStateParams = Omit<SetStateParamsTSMorphBase, "farmIds">;;

type GetDriverOverlapsParamsTSMorphBase = {
farmIds: number;
}

export type GetDriverOverlapsParams = Omit<GetDriverOverlapsParamsTSMorphBase, "farmIds">;;

type GetHandworkRecordsParamsTSMorphBase = {
farmIds: number;
driver: string;
date: string;
language?: string;
}

export type GetHandworkRecordsParams = Omit<GetHandworkRecordsParamsTSMorphBase, "farmIds">;;

type CreateHandworkParamsTSMorphBase = {
farmIds: number;
language?: string;
}

export type CreateHandworkParams = Omit<CreateHandworkParamsTSMorphBase, "farmIds">;;

type PrecalculateIntervalsParamsTSMorphBase = {
farmIds: number;
}

export type PrecalculateIntervalsParams = Omit<PrecalculateIntervalsParamsTSMorphBase, "farmIds">;;

type UpdateSubjectParamsTSMorphBase = {
farmIds: number;
language?: string;
}

export type UpdateSubjectParams = Omit<UpdateSubjectParamsTSMorphBase, "farmIds">;;

type UpdateProductionOperationParamsTSMorphBase = {
farmIds: number;
language?: string;
}

export type UpdateProductionOperationParams = Omit<UpdateProductionOperationParamsTSMorphBase, "farmIds">;;

type UpdateCustomerKeyParamsTSMorphBase = {
farmIds: number;
language?: string;
}

export type UpdateCustomerKeyParams = Omit<UpdateCustomerKeyParamsTSMorphBase, "farmIds">;;

type UpdateEquipment1ParamsTSMorphBase = {
farmIds: number;
language?: string;
}

export type UpdateEquipment1Params = Omit<UpdateEquipment1ParamsTSMorphBase, "farmIds">;;

type UpdateDriver1ParamsTSMorphBase = {
farmIds: number;
language?: string;
}

export type UpdateDriver1Params = Omit<UpdateDriver1ParamsTSMorphBase, "farmIds">;;

type UpdateBonusParamsTSMorphBase = {
farmIds: number;
language?: string;
}

export type UpdateBonusParams = Omit<UpdateBonusParamsTSMorphBase, "farmIds">;;

type GetKeysCombinationsParamsTSMorphBase = {
type: KeyType;
farmIds: number;
}

export type GetKeysCombinationsParams = Omit<GetKeysCombinationsParamsTSMorphBase, "farmIds">;;

type GetClientsParamsTSMorphBase = {
search?: string;
farmIds: number;
dateFrom?: string;
dateTo?: string;
}

export type GetClientsParams = Omit<GetClientsParamsTSMorphBase, "farmIds">;;

export type GetAllParams = {
language?: string;
};

export type ValueForKeyParams = {
language?: string;
};

export type GetAll1Params = {
farmIds?: number;
search?: string;
language?: string;
handwork?: boolean;
};

type GetAll2ParamsTSMorphBase = {
farmIds: number;
language?: string;
search?: string;
dateFrom?: string;
dateTo?: string;
catalogue?: Catalogue;
page?: number;
'per-page'?: number;
'sort-col'?: MachineSortColumn;
'sort-dir'?: string;
}

export type GetAll2Params = Omit<GetAll2ParamsTSMorphBase, "farmIds">;;

type GetAll3ParamsTSMorphBase = {
farmIds: number;
drivers?: string[];
machines?: string[];
}

export type GetAll3Params = Omit<GetAll3ParamsTSMorphBase, "farmIds">;;

type GetLogbookDashboardParamsTSMorphBase = {
farmIds: number;
'date-from': string;
'date-to': string;
}

export type GetLogbookDashboardParams = Omit<GetLogbookDashboardParamsTSMorphBase, "farmIds">;;

type GetLivePositionsParamsTSMorphBase = {
farmIds: number;
drivers?: string[];
machines?: string[];
}

export type GetLivePositionsParams = Omit<GetLivePositionsParamsTSMorphBase, "farmIds">;;

type GetPositionFeaturesParamsTSMorphBase = {
farmIds: number;
'gps-unit': string;
}

export type GetPositionFeaturesParams = Omit<GetPositionFeaturesParamsTSMorphBase, "farmIds">;;

type GetPositionFeaturesV2ParamsTSMorphBase = {
farmIds: number;
'gps-unit': string;
}

export type GetPositionFeaturesV2Params = Omit<GetPositionFeaturesV2ParamsTSMorphBase, "farmIds">;;

type GetLiveDashboardParamsTSMorphBase = {
farmIds: number;
search?: string;
'sort-col'?: PositionSort;
'sort-dir'?: string;
state?: PositionState[];
machineGroup?: MachineGroupCode[];
}

export type GetLiveDashboardParams = Omit<GetLiveDashboardParamsTSMorphBase, "farmIds">;;

type GetPositionHistoryParamsTSMorphBase = {
farmIds: number;
drivers?: string[];
machines?: string[];
'date-from': string;
'date-to'?: string;
}

export type GetPositionHistoryParams = Omit<GetPositionHistoryParamsTSMorphBase, "farmIds">;;

type GetDashboardParamsTSMorphBase = {
farmIds: number;
search?: string;
'sort-col'?: PositionSort;
'sort-dir'?: string;
state?: PositionState[];
machineGroup?: MachineGroupCode[];
}

export type GetDashboardParams = Omit<GetDashboardParamsTSMorphBase, "farmIds">;;

export type GetMachineGroupsParams = {
language?: string;
};

type GetMachineByGpsParamsTSMorphBase = {
farmIds: number;
language?: string;
}

export type GetMachineByGpsParams = Omit<GetMachineByGpsParamsTSMorphBase, "farmIds">;;

export type GetMachineCategoriesParams = {
language?: string;
};

type DriveDetailParamsTSMorphBase = {
farmIds: number;
language?: string;
}

export type DriveDetailParams = Omit<DriveDetailParamsTSMorphBase, "farmIds">;;

type TosStateParamsTSMorphBase = {
farmIds: number;
language?: string;
}

export type TosStateParams = Omit<TosStateParamsTSMorphBase, "farmIds">;;

type TosHealthParamsTSMorphBase = {
farmIds: number;
}

export type TosHealthParams = Omit<TosHealthParamsTSMorphBase, "farmIds">;;

type LogbookExportParamsTSMorphBase = {
farmIds: number;
language?: string;
dateFrom?: string;
dateTo?: string;
search?: string;
actionState?: string[];
crop?: number[];
operation?: TelematicsOperation[];
affiliation?: Affiliation[];
productionOperation?: string[];
actionType?: string[];
parcel?: number[];
parcelSubjectId?: string[];
driver?: string[];
gpsUnit?: string[];
equipment?: string[];
state?: State[];
}

export type LogbookExportParams = Omit<LogbookExportParamsTSMorphBase, "farmIds">;;

type LogbookAggregatedRecordsExportParamsTSMorphBase = {
farmIds: number;
language?: string;
dateFrom?: string;
dateTo?: string;
search?: string;
actionState?: string[];
crop?: number[];
operation?: TelematicsOperation[];
affiliation?: Affiliation[];
productionOperation?: string[];
actionType?: string[];
parcel?: number[];
parcelSubjectId?: string[];
driver?: string[];
gpsUnit?: string[];
equipment?: string[];
state?: State[];
}

export type LogbookAggregatedRecordsExportParams = Omit<LogbookAggregatedRecordsExportParamsTSMorphBase, "farmIds">;;

type LogbookAggregatedExportParamsTSMorphBase = {
farmIds: number;
language?: string;
dateFrom?: string;
dateTo?: string;
driver?: string;
machine?: string;
state?: State[];
}

export type LogbookAggregatedExportParams = Omit<LogbookAggregatedExportParamsTSMorphBase, "farmIds">;;

type GetCustomerKeyCalculationParamsTSMorphBase = {
farmIds: number;
}

export type GetCustomerKeyCalculationParams = Omit<GetCustomerKeyCalculationParamsTSMorphBase, "farmIds">;;

type GetClients1ParamsTSMorphBase = {
search?: string;
farmIds: number;
dateFrom?: string;
dateTo?: string;
}

export type GetClients1Params = Omit<GetClients1ParamsTSMorphBase, "farmIds">;;

type DriveParcelParamsTSMorphBase = {
season?: number;
farmIds: number;
}

export type DriveParcelParams = Omit<DriveParcelParamsTSMorphBase, "farmIds">;;

type GetDriveOverlapsParamsTSMorphBase = {
farmIds: number;
}

export type GetDriveOverlapsParams = Omit<GetDriveOverlapsParamsTSMorphBase, "farmIds">;;

type GetKeysParamsTSMorphBase = {
farmIds: number;
}

export type GetKeysParams = Omit<GetKeysParamsTSMorphBase, "farmIds">;;

type GetKeysCombinations1ParamsTSMorphBase = {
type: KeyType;
farmIds: number;
}

export type GetKeysCombinations1Params = Omit<GetKeysCombinations1ParamsTSMorphBase, "farmIds">;;

type GetDriveSubjectsParamsTSMorphBase = {
farmIds: number;
search?: string;
}

export type GetDriveSubjectsParams = Omit<GetDriveSubjectsParamsTSMorphBase, "farmIds">;;

type AggregatedRecordsParamsTSMorphBase = {
farmIds: number;
page?: number;
'per-page'?: number;
'sort-col'?: LogbookDriveSortColumn;
'sort-dir'?: string;
language?: string;
dateFrom?: string;
dateTo?: string;
search?: string;
actionState?: string[];
crop?: number[];
operation?: TelematicsOperation[];
affiliation?: Affiliation[];
productionOperation?: string[];
actionType?: string[];
parcel?: number[];
parcelSubjectId?: string[];
driver?: string[];
gpsUnit?: string[];
equipment?: string[];
state?: State[];
}

export type AggregatedRecordsParams = Omit<AggregatedRecordsParamsTSMorphBase, "farmIds">;;

type LogbookByMachinesParamsTSMorphBase = {
farmIds: number;
page?: number;
'per-page'?: number;
'sort-col'?: LogbookAggregatedSortColumn;
'sort-dir'?: string;
language?: string;
dateFrom?: string;
dateTo?: string;
driver?: string;
machine?: string;
state?: State[];
}

export type LogbookByMachinesParams = Omit<LogbookByMachinesParamsTSMorphBase, "farmIds">;;

type Logbook1ParamsTSMorphBase = {
farmIds: number;
language?: string;
}

export type Logbook1Params = Omit<Logbook1ParamsTSMorphBase, "farmIds">;;

export type GetAll4Params = {
farmIds?: number;
language?: string;
page?: number;
'per-page'?: number;
sources?: Source[];
};

export type GetStateParams = {
farmIds?: number;
language?: string;
};

type GetAll5ParamsTSMorphBase = {
language?: string;
farmIds: number;
search?: string;
dateFrom?: string;
dateTo?: string;
page?: number;
'per-page'?: number;
'sort-col'?: EquipmentSortColumn;
'sort-dir'?: string;
}

export type GetAll5Params = Omit<GetAll5ParamsTSMorphBase, "farmIds">;;

type GetEquipmentByCodeParamsTSMorphBase = {
farmIds: number;
language?: string;
}

export type GetEquipmentByCodeParams = Omit<GetEquipmentByCodeParamsTSMorphBase, "farmIds">;;

type GetAll6ParamsTSMorphBase = {
language?: string;
farmIds: number;
search?: string;
dateFrom?: string;
dateTo?: string;
page?: number;
'per-page'?: number;
'sort-col'?: DriverSortColumn;
'sort-dir'?: string;
}

export type GetAll6Params = Omit<GetAll6ParamsTSMorphBase, "farmIds">;;

type GetDriverByCodeParamsTSMorphBase = {
farmIds: number;
}

export type GetDriverByCodeParams = Omit<GetDriverByCodeParamsTSMorphBase, "farmIds">;;

export type GetAll7Params = {
language?: string;
farmIds?: number;
search?: string;
dateFrom?: string;
dateTo?: string;
page?: number;
'per-page'?: number;
'sort-col'?: CropSortColumn;
'sort-dir'?: string;
};

export type GetAccountParams = {
farmIds?: number;
'company-id': string;
};

type GetStatusParamsTSMorphBase = {
farmIds: number;
}

export type GetStatusParams = Omit<GetStatusParamsTSMorphBase, "farmIds">;;

type DeleteRuleParamsTSMorphBase = {
farmIds: number;
}

export type DeleteRuleParams = Omit<DeleteRuleParamsTSMorphBase, "farmIds">;;

export const updateMachine = <TData = AxiosResponse<null>>(
    machineId: number,
    machineUpdateTo: MachineUpdateTo,
    params?: UpdateMachineParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.TELEMATICS_URL}/api/machines/${machineId}`,
      machineUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export const get = <TData = AxiosResponse<WinfasTo>>(
    id: number,
    params: GetParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/${id}/winfas`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const updateKeys = <TData = AxiosResponse<WinfasTo>>(
    id: number,
    winfasUpdateTo: WinfasUpdateTo,
    params: UpdateKeysParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/${id}/winfas`,
      winfasUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Return detail of a single handwork drive including original request times. Drive trajectory is sent in GeoJSON format.
 */
export const handworkDetail = <TData = AxiosResponse<HandworkDetailTo>>(
    id: number,
    params: HandworkDetailParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/handwork/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Update handwork entry
 */
export const updateHandwork = <TData = AxiosResponse<null>>(
    id: number,
    handworkCreateTo: HandworkCreateTo,
    params: UpdateHandworkParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/handwork/${id}`,
      handworkCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export const updateEquipment = <TData = AxiosResponse<null>>(
    equipmentId: number,
    equipmentUpdateTo: EquipmentUpdateTo,
    params?: UpdateEquipmentParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.TELEMATICS_URL}/api/equipments/${equipmentId}`,
      equipmentUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export const updateDriver = <TData = AxiosResponse<null>>(
    driverId: number,
    driverUpdateTo: DriverUpdateTo,
    params?: UpdateDriverParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.TELEMATICS_URL}/api/drivers/${driverId}`,
      driverUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export const getAll8 = <TData = AxiosResponse<AccountTo[]>>(
    params?: GetAll8Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/admin/account`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const put = <TData = AxiosResponse<AccountTo[]>>(
    accountUpdateTo: AccountUpdateTo[], options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.put(
      `${window.ENV.TELEMATICS_URL}/api/admin/account`,
      accountUpdateTo,options
    );
  }

export const create2 = <TData = AxiosResponse<AccountTo>>(
    accountCreateTo: AccountCreateTo, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/api/admin/account`,
      accountCreateTo,options
    );
  }

export const patch = <TData = AxiosResponse<AccountTo[]>>(
    accountUpdateTo: AccountUpdateTo[], options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.patch(
      `${window.ENV.TELEMATICS_URL}/api/admin/account`,
      accountUpdateTo,options
    );
  }

export const reloadTestData = <TData = AxiosResponse<null>>(
    e2eDriveRequest: E2eDriveRequest[], options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/e2e/api/reload`,
      e2eDriveRequest,options
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * List all drive classification rules for the farm
 */
export const listRules = <TData = AxiosResponse<RuleResponseTo[]>>(
    params: ListRulesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/rules`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Create a new drive classification rule for the farm
 */
export const createRule = <TData = AxiosResponse<RuleResponseTo>>(
    ruleCreateTo: RuleCreateTo,
    params: CreateRuleParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/api/rules`,
      ruleCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns logbook position trajectories from the database for a given time range for specific driver/machine pairs. Does not include live data.
 */
export const getLogbookPositions = <TData = AxiosResponse<DailyPositionTo[]>>(
    positionLogbookRequestTo: PositionLogbookRequestTo,
    params: GetLogbookPositionsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/api/machines/position/logbook`,
      positionLogbookRequestTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns logbook position data as a simple list with time, position, and calculated speed. Supports flexible filtering by machine, driver, or both using the type field.
 * @deprecated
 */
export const getLogbookFeatures = <TData = AxiosResponse<PositionFeatureTo[]>>(
    positionLogbookDriverMachinePair: PositionLogbookDriverMachinePair,
    params: GetLogbookFeaturesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/api/machines/position/logbook/features`,
      positionLogbookDriverMachinePair,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns logbook position data grouped by drive parts. Each inner list represents positions from a single drive part, allowing separation of different segments of a drive.
 */
export const getLogbookFeaturesV2 = <TData = AxiosResponse<PositionFeatureTo[][]>>(
    positionLogbookDriverMachinePair: PositionLogbookDriverMachinePair,
    params: GetLogbookFeaturesV2Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/api/machines/position/logbook/features/v2`,
      positionLogbookDriverMachinePair,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Return list of all drives
 */
export const logbook = <TData = AxiosResponse<LogbookItemTo[]>>(
    params: LogbookParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/logbook`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const create = <TData = AxiosResponse<DrivePartDetailTo>>(
    drivePartCreateTo: DrivePartCreateTo,
    params: CreateParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/api/logbook`,
      drivePartCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Export drives to TOS
 */
export const tosExport = <TData = AxiosResponse<null>>(
    params: TosExportParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/api/logbook/tos`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * Export selected drives to TOS
 */
export const tosExcelExport = <TData = AxiosResponse<Blob>>(
    params: TosExcelExportParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/api/logbook/tos/excel`,undefined,{
        responseType: 'blob',
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Return list of all aggregated drives
 */
export const logbookByDrivers = <TData = AxiosResponse<LogbookAggregatedTo[]>>(
    params: LogbookByDriversParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const create1 = <TData = AxiosResponse<DriveDetailTo>>(
    driveCreateTo: DriveCreateTo,
    params: Create1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated`,
      driveCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Return detail of a single drive. Drive trajectory is sent in GeoJSON format.
 */
export const driveDetail1 = <TData = AxiosResponse<DriveDetailTo>>(
    id: number,
    params: DriveDetail1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const update = <TData = AxiosResponse<DriveDetailTo>>(
    id: number,
    driveUpdateTo: DriveUpdateTo,
    params: UpdateParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/${id}`,
      driveUpdateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const _delete = <TData = AxiosResponse<null>>(
    id: number,
    params: _DeleteParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export const separateDriveByTime = <TData = AxiosResponse<null>>(
    id: number,
    driveSeparationTimeTo: DriveSeparationTimeTo,
    params: SeparateDriveByTimeParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/${id}/separation/time`,
      driveSeparationTimeTo,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export const separateDriveByInterval = <TData = AxiosResponse<null>>(
    id: number,
    driveSeparationIntervalsTo: DriveSeparationIntervalsTo,
    params: SeparateDriveByIntervalParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/${id}/separation/interval`,
      driveSeparationIntervalsTo,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export const recalculateArea = <TData = AxiosResponse<DriveAreaTo>>(
    id: number,
    driveRecalculateTo: DriveRecalculateTo,
    params: RecalculateAreaParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/${id}/area`,
      driveRecalculateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const setState = <TData = AxiosResponse<null>>(
    driveUpdateStateTo: DriveUpdateStateTo,
    params: SetStateParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/state`,
      driveUpdateStateTo,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export const getDriverOverlaps = <TData = AxiosResponse<DriveDetailOverlapTo[]>>(
    driveOverlapRequestTo: DriveOverlapRequestTo,
    params: GetDriverOverlapsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/overlaps`,
      driveOverlapRequestTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Get handwork records for specified driver and date with original request times
 */
export const getHandworkRecords = <TData = AxiosResponse<HandworkAggregatedItemTo[]>>(
    params: GetHandworkRecordsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/handwork`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Create handwork entry
 */
export const createHandwork = <TData = AxiosResponse<DriveDetailTo>>(
    handworkCreateTo: HandworkCreateTo,
    params: CreateHandworkParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/handwork`,
      handworkCreateTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Precalculate available time intervals for handwork
 */
export const precalculateIntervals = <TData = AxiosResponse<HandworkPrecalculateResponseTo>>(
    handworkPrecalculateRequestTo: HandworkPrecalculateRequestTo,
    params: PrecalculateIntervalsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/handwork/precalculate`,
      handworkPrecalculateRequestTo,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const updateSubject = <TData = AxiosResponse<null>>(
    driveBatchUpdateSubjectTo: DriveBatchUpdateSubjectTo,
    params: UpdateSubjectParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/batch/subject`,
      driveBatchUpdateSubjectTo,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export const updateProductionOperation = <TData = AxiosResponse<null>>(
    driveBatchUpdateProductionOperationTo: DriveBatchUpdateProductionOperationTo,
    params: UpdateProductionOperationParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/batch/operation`,
      driveBatchUpdateProductionOperationTo,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export const updateCustomerKey = <TData = AxiosResponse<null>>(
    driveBatchUpdateCustomerKeyTo: DriveBatchUpdateCustomerKeyTo,
    params: UpdateCustomerKeyParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/batch/key/customer`,
      driveBatchUpdateCustomerKeyTo,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export const updateEquipment1 = <TData = AxiosResponse<null>>(
    driveBatchUpdateEquipmentTo: DriveBatchUpdateEquipmentTo,
    params: UpdateEquipment1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/batch/equipment`,
      driveBatchUpdateEquipmentTo,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export const updateDriver1 = <TData = AxiosResponse<null>>(
    driveBatchUpdateDriverTo: DriveBatchUpdateDriverTo,
    params: UpdateDriver1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/batch/driver`,
      driveBatchUpdateDriverTo,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export const updateBonus = <TData = AxiosResponse<null>>(
    driveBatchUpdateBonusTo: DriveBatchUpdateBonusTo,
    params: UpdateBonusParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/batch/bonus`,
      driveBatchUpdateBonusTo,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

/**
 * Restarts a EUROWAG drive import that is in ERROR state asynchronously. Validates that no other imports are running and that the import has a valid filename. Returns 202 Accepted immediately after validation.
 * @summary Restart a failed drive import
 */
export const restartImport = <TData = AxiosResponse<null>>(
    importId: number, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `${window.ENV.TELEMATICS_URL}/api/admin/import/${importId}/restart`,undefined,options
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export const getKeysCombinations = <TData = AxiosResponse<DriveKeyTo[]>>(
    params: GetKeysCombinationsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/winfas/key/combinations`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getClients = <TData = AxiosResponse<WinfasClientTo[]>>(
    params: GetClientsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/winfas/clients`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns list of all operations.
 */
export const getAll = <TData = AxiosResponse<OperationTo[]>>(
    params?: GetAllParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/operations`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns an operation entry based on the provided key.
 */
export const valueForKey = <TData = AxiosResponse<OperationTo>>(
    key: string,
    params?: ValueForKeyParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/operations/${key}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getAll1 = <TData = AxiosResponse<ProductionOperationTo[]>>(
    params?: GetAll1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/operations/production`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getAll2 = <TData = AxiosResponse<MachineTo[]>>(
    params: GetAll2Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/machines`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @deprecated
 */
export const getAll3 = <TData = AxiosResponse<PositionDetailTo[]>>(
    params: GetAll3Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/machines/position`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getLogbookDashboard = <TData = AxiosResponse<PositionLogbookDashboardTo[]>>(
    params: GetLogbookDashboardParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/machines/position/logbook/dashboard`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns live position data from the live position service. Optionally specify a dateFrom within today to filter results.
 */
export const getLivePositions = <TData = AxiosResponse<DailyPositionTo[]>>(
    params: GetLivePositionsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/machines/position/live`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns position data as a simple list with time, position, and speed for a specific GPS unit.
 * @deprecated
 */
export const getPositionFeatures = <TData = AxiosResponse<PositionFeatureTo[]>>(
    params: GetPositionFeaturesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/machines/position/live/features`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns position data wrapped in an outer list for consistency with logbook V2 format. Currently returns a single inner list with all positions (no separation).
 */
export const getPositionFeaturesV2 = <TData = AxiosResponse<PositionFeatureTo[][]>>(
    params: GetPositionFeaturesV2Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/machines/position/live/features/v2`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getLiveDashboard = <TData = AxiosResponse<PositionDashboard[]>>(
    params: GetLiveDashboardParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/machines/position/live/dashboard`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns trajectories for a given time range. Supports additional filtering by machine and driver.
 * @deprecated
 */
export const getPositionHistory = <TData = AxiosResponse<DailyPositionTo[]>>(
    params: GetPositionHistoryParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/machines/position/history`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @deprecated
 */
export const getDashboard = <TData = AxiosResponse<PositionDashboard[]>>(
    params: GetDashboardParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/machines/position/dashboard`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getMachineGroups = <TData = AxiosResponse<MachineGroupTo[]>>(
    params?: GetMachineGroupsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/machines/groups`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getMachineByGps = <TData = AxiosResponse<MachineTo>>(
    machineGpsUnit: string,
    params: GetMachineByGpsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/machines/gps/${machineGpsUnit}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getMachineCategories = <TData = AxiosResponse<MachineGroupCategoryTo[]>>(
    params?: GetMachineCategoriesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/machines/categories`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Return detail of a single drive. Drive trajectory is sent in GeoJSON format.
 */
export const driveDetail = <TData = AxiosResponse<DrivePartDetailTo>>(
    id: number,
    params: DriveDetailParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/logbook/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Get current data stats ready to export
 */
export const tosState = <TData = AxiosResponse<EconomicStatsTo>>(
    params: TosStateParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/logbook/tos/status`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Get connection status to the third party database
 */
export const tosHealth = <TData = AxiosResponse<boolean>>(
    params: TosHealthParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/logbook/tos/health`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns file of logbook records by given criteria
 */
export const logbookExport = <TData = AxiosResponse<StreamingResponseBody>>(
    params: LogbookExportParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/logbook/export/excel`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns file of aggregated logbook records by given criteria
 */
export const logbookAggregatedRecordsExport = <TData = AxiosResponse<StreamingResponseBody>>(
    params: LogbookAggregatedRecordsExportParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/logbook/export/aggregated/records/excel`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns file of aggregated logbook records by given criteria
 */
export const logbookAggregatedExport = <TData = AxiosResponse<StreamingResponseBody>>(
    params: LogbookAggregatedExportParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/logbook/export/aggregated/excel`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Returns detailed breakdown of how the customer key was calculated for tooltip display.

            Calculation types:
            - STANDARD_CALCULATION: Keys calculated automatically for COMPANY affiliation
            - USES_SUPPLIER_KEY: EXTERNAL affiliation uses supplier key as customer key
            - MANUAL_OVERRIDE: Keys were manually set by user via API (no automatic calculation)
            - NOT_CALCULABLE: Automatic calculation failed due to missing required data

            When calculationType is MANUAL_OVERRIDE, all calculation detail fields will be null.
 * @summary Get customer key calculation details
 */
export const getCustomerKeyCalculation = <TData = AxiosResponse<CustomerKeyCalculationTo>>(
    id: number,
    params: GetCustomerKeyCalculationParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/${id}/winfas/customer-key-calculation`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @deprecated
 */
export const getClients1 = <TData = AxiosResponse<WinfasClientTo[]>>(
    id: number,
    params: GetClients1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/${id}/winfas/clients`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Return parcels available for this drive
 */
export const driveParcel = <TData = AxiosResponse<DriveParcelCropTo>>(
    id: number,
    parcelId: string,
    params: DriveParcelParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/${id}/parcel/${parcelId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getDriveOverlaps = <TData = AxiosResponse<DriveDetailOverlapTo[]>>(
    id: number,
    params: GetDriveOverlapsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/${id}/overlaps`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @deprecated
 */
export const getKeys = <TData = AxiosResponse<DriveKeysTo>>(
    id: number,
    params: GetKeysParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/${id}/key`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @deprecated
 */
export const getKeysCombinations1 = <TData = AxiosResponse<DriveKeyTo[]>>(
    id: number,
    params: GetKeysCombinations1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/${id}/key/combinations`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Return list of all drive subjects
 */
export const getDriveSubjects = <TData = AxiosResponse<DriveSubjectTo[]>>(
    params: GetDriveSubjectsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/subject`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Return list of all aggregated records
 */
export const aggregatedRecords = <TData = AxiosResponse<LogbookAggregatedItemTo[]>>(
    params: AggregatedRecordsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/records`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Return list of all aggregated drives by machine
 */
export const logbookByMachines = <TData = AxiosResponse<LogbookAggregatedMachineTo[]>>(
    params: LogbookByMachinesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/logbook/aggregated/machine`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Return all drives for provided action
 */
export const logbook1 = <TData = AxiosResponse<ActionDrivesTo>>(
    actionId: number,
    params: Logbook1Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/logbook/action/${actionId}/drive`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getAll4 = <TData = AxiosResponse<DriveImportTo[]>>(
    params?: GetAll4Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/import`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getState = <TData = AxiosResponse<DriveImportTo>>(
    params?: GetStateParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/import/state`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getAll5 = <TData = AxiosResponse<EquipmentTo[]>>(
    params: GetAll5Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/equipments`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getEquipmentByCode = <TData = AxiosResponse<EquipmentTo>>(
    equipmentCode: string,
    params: GetEquipmentByCodeParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/equipments/code/${equipmentCode}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getAll6 = <TData = AxiosResponse<DriverTo[]>>(
    params: GetAll6Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/drivers`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getDriverByCode = <TData = AxiosResponse<DriverTo>>(
    driverCode: string,
    params: GetDriverByCodeParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/drivers/code/${driverCode}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getAll7 = <TData = AxiosResponse<CropTo[]>>(
    params?: GetAll7Params, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/crops`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getCountries = <TData = AxiosResponse<string[]>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/admin/account/country`,options
    );
  }

export const getAccount = <TData = AxiosResponse<AccountTo>>(
    params: GetAccountParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/account`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

export const getStatus = <TData = AxiosResponse<AccountStatusTo>>(
    params: GetStatusParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `${window.ENV.TELEMATICS_URL}/api/account/status`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Delete a drive classification rule
 */
export const deleteRule = <TData = AxiosResponse<null>>(
    ruleId: number,
    params: DeleteRuleParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.delete(
      `${window.ENV.TELEMATICS_URL}/api/rules/${ruleId}`,{
    ...options,
        params: {...params, ...options?.params},}
    ).then((res) => {if (res.data === "") res.data = null; return res as TData;});
  }

export type UpdateMachineResult = AxiosResponse<null>
export type GetResult = AxiosResponse<WinfasTo>
export type UpdateKeysResult = AxiosResponse<WinfasTo>
export type HandworkDetailResult = AxiosResponse<HandworkDetailTo>
export type UpdateHandworkResult = AxiosResponse<null>
export type UpdateEquipmentResult = AxiosResponse<null>
export type UpdateDriverResult = AxiosResponse<null>
export type GetAll8Result = AxiosResponse<AccountTo[]>
export type PutResult = AxiosResponse<AccountTo[]>
export type Create2Result = AxiosResponse<AccountTo>
export type PatchResult = AxiosResponse<AccountTo[]>
export type ReloadTestDataResult = AxiosResponse<null>
export type ListRulesResult = AxiosResponse<RuleResponseTo[]>
export type CreateRuleResult = AxiosResponse<RuleResponseTo>
export type GetLogbookPositionsResult = AxiosResponse<DailyPositionTo[]>
export type GetLogbookFeaturesResult = AxiosResponse<PositionFeatureTo[]>
export type GetLogbookFeaturesV2Result = AxiosResponse<PositionFeatureTo[][]>
export type LogbookResult = AxiosResponse<LogbookItemTo[]>
export type CreateResult = AxiosResponse<DrivePartDetailTo>
export type TosExportResult = AxiosResponse<null>
export type TosExcelExportResult = AxiosResponse<Blob>
export type LogbookByDriversResult = AxiosResponse<LogbookAggregatedTo[]>
export type Create1Result = AxiosResponse<DriveDetailTo>
export type DriveDetail1Result = AxiosResponse<DriveDetailTo>
export type UpdateResult = AxiosResponse<DriveDetailTo>
export type _DeleteResult = AxiosResponse<null>
export type SeparateDriveByTimeResult = AxiosResponse<null>
export type SeparateDriveByIntervalResult = AxiosResponse<null>
export type RecalculateAreaResult = AxiosResponse<DriveAreaTo>
export type SetStateResult = AxiosResponse<null>
export type GetDriverOverlapsResult = AxiosResponse<DriveDetailOverlapTo[]>
export type GetHandworkRecordsResult = AxiosResponse<HandworkAggregatedItemTo[]>
export type CreateHandworkResult = AxiosResponse<DriveDetailTo>
export type PrecalculateIntervalsResult = AxiosResponse<HandworkPrecalculateResponseTo>
export type UpdateSubjectResult = AxiosResponse<null>
export type UpdateProductionOperationResult = AxiosResponse<null>
export type UpdateCustomerKeyResult = AxiosResponse<null>
export type UpdateEquipment1Result = AxiosResponse<null>
export type UpdateDriver1Result = AxiosResponse<null>
export type UpdateBonusResult = AxiosResponse<null>
export type RestartImportResult = AxiosResponse<null>
export type GetKeysCombinationsResult = AxiosResponse<DriveKeyTo[]>
export type GetClientsResult = AxiosResponse<WinfasClientTo[]>
export type GetAllResult = AxiosResponse<OperationTo[]>
export type ValueForKeyResult = AxiosResponse<OperationTo>
export type GetAll1Result = AxiosResponse<ProductionOperationTo[]>
export type GetAll2Result = AxiosResponse<MachineTo[]>
export type GetAll3Result = AxiosResponse<PositionDetailTo[]>
export type GetLogbookDashboardResult = AxiosResponse<PositionLogbookDashboardTo[]>
export type GetLivePositionsResult = AxiosResponse<DailyPositionTo[]>
export type GetPositionFeaturesResult = AxiosResponse<PositionFeatureTo[]>
export type GetPositionFeaturesV2Result = AxiosResponse<PositionFeatureTo[][]>
export type GetLiveDashboardResult = AxiosResponse<PositionDashboard[]>
export type GetPositionHistoryResult = AxiosResponse<DailyPositionTo[]>
export type GetDashboardResult = AxiosResponse<PositionDashboard[]>
export type GetMachineGroupsResult = AxiosResponse<MachineGroupTo[]>
export type GetMachineByGpsResult = AxiosResponse<MachineTo>
export type GetMachineCategoriesResult = AxiosResponse<MachineGroupCategoryTo[]>
export type DriveDetailResult = AxiosResponse<DrivePartDetailTo>
export type TosStateResult = AxiosResponse<EconomicStatsTo>
export type TosHealthResult = AxiosResponse<boolean>
export type LogbookExportResult = AxiosResponse<StreamingResponseBody>
export type LogbookAggregatedRecordsExportResult = AxiosResponse<StreamingResponseBody>
export type LogbookAggregatedExportResult = AxiosResponse<StreamingResponseBody>
export type GetCustomerKeyCalculationResult = AxiosResponse<CustomerKeyCalculationTo>
export type GetClients1Result = AxiosResponse<WinfasClientTo[]>
export type DriveParcelResult = AxiosResponse<DriveParcelCropTo>
export type GetDriveOverlapsResult = AxiosResponse<DriveDetailOverlapTo[]>
export type GetKeysResult = AxiosResponse<DriveKeysTo>
export type GetKeysCombinations1Result = AxiosResponse<DriveKeyTo[]>
export type GetDriveSubjectsResult = AxiosResponse<DriveSubjectTo[]>
export type AggregatedRecordsResult = AxiosResponse<LogbookAggregatedItemTo[]>
export type LogbookByMachinesResult = AxiosResponse<LogbookAggregatedMachineTo[]>
export type Logbook1Result = AxiosResponse<ActionDrivesTo>
export type GetAll4Result = AxiosResponse<DriveImportTo[]>
export type GetStateResult = AxiosResponse<DriveImportTo>
export type GetAll5Result = AxiosResponse<EquipmentTo[]>
export type GetEquipmentByCodeResult = AxiosResponse<EquipmentTo>
export type GetAll6Result = AxiosResponse<DriverTo[]>
export type GetDriverByCodeResult = AxiosResponse<DriverTo>
export type GetAll7Result = AxiosResponse<CropTo[]>
export type GetCountriesResult = AxiosResponse<string[]>
export type GetAccountResult = AxiosResponse<AccountTo>
export type GetStatusResult = AxiosResponse<AccountStatusTo>
export type DeleteRuleResult = AxiosResponse<null>
